export default class articles {
  constructor() {
    this.$filterButton = $('.articles__main .articles-blocks .select-block select');
    this.$filterButton.on('change', (e) => this.filterArticles(e));
  }

  filterArticles(e) {
    const $button = $(e.target).closest('select[id="filter-by"]');
    const filterName = $button.val();

    const $container = $button.closest('.articles-blocks').find('.row');
    const $template = $container.find('.template-column');
    const $articles = $container.find('.column:not(.template-column)');

    // Remove all article blocks
    $articles.remove();

    $.ajax({
      url: $button.closest('.select-block__wrapper').data('ajax-url'),
      type: 'POST',
      dataType: 'json',
      data: {
        filter_name: filterName,
        action: 'filter_articles',
      },
      beforeSend: () => {},
      success: (response) => {
        let delay = 0;
        if (typeof response.posts !== 'undefined') {
          response.posts.map((item) => {
            // clone template
            const $post = $template.clone();

            // remove default attributes
            $post.attr('aria-hidden', 'false');
            $post.removeClass('template-column visuallyhidden');
            $post.addClass('animated fadeIn animated-delay-' + delay);

            // set response data
            $post.find('.article-block__image').attr('href', item.permalink);
            $post.find('.article-block__image').css('background-image', 'url("' + item.background + '")');
            $post.find('.article-block__content .title a').attr('href', item.permalink);
            $post.find('.article-block__content .title a').text(item.title);
            $post.find('.article-block__content .text').text(item.text);
            $post.find('.article-block__content .button-show').attr('href', item.permalink);

            // append to row
            $post.appendTo($container);
            delay += 1;
          });
        }
      },
    });
  }
}



// WEBPACK FOOTER //
// ./scripts/articles.js